<template>
  <el-table
    :data="tabledata"
    height="420"
    style="width: 100%"
    @row-click="rowClick"
  >
    <div v-for="(item, index) in tableProp" :key="index">
      <el-table-column
        v-if="item.prop !== 'cancelType'"
        :label="item.label"
        :prop="item.prop"
      />
      <!-- 撤案类型 -->
      <el-table-column v-else :label="item.label" :prop="item.prop">
        <template slot-scope="scope">
          {{
            scope.row.cancelType == 1
              ? "重新分案"
              : scope.row.cancelType == 2
              ? "催收成功"
              : "-"
          }}
        </template>
      </el-table-column>
      <!-- 分案渠道 -->
      <!-- <el-table-column v-else :label="item.label" :prop="item.prop">
        <template slot-scope="scope">
          {{
            scope.row.divisionType === "-1"
              ? "撤案"
              : scope.row.divisionType === "0"
              ? "自动"
              : scope.row.divisionType === "1"
              ? "手动"
              : scope.row.divisionType === "2"
              ? "批量分案"
              : "-"
          }}
        </template>
      </el-table-column> -->
    </div>
    <el-table-column label="操作" v-if="type === 'contactsInfo'">
      <template slot-scope="scope">
          <!-- v-if="scope.row.relation === '本人'" -->
        <el-button
          type="text"
          @click="call(scope.row.contactPhone)"
          >拨打</el-button
        >
        <el-button v-if="scope.row.typeCode === 'self_other' || scope.row.typeCode === 'other_contact'"
          type="text"
          @click="editOpen(scope.row)"
          >编辑</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Lib from "./lib.js";
export default {
  name: "informationTable",
  props: {
    tabledata: {
      type: [Array, null],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    tableProp() {
      return Lib.tableProp[this.type];
    },
  },
  methods: {
    rowClick(row) {
      this.$emit("rowClick", row);
    },
    editOpen(row) {
      console.log('row:',row)
      this.$emit("editOpen", row);
    },
    call( phone ) {
      this.$confirm("是否确认呼出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // eslint-disable-next-line no-undef
          DYSDK.call(phone, (phone) => {
            console.log("call方法回调", phone);
          });
        })
        .catch(() => {});
    },
  },
};
</script>
